import React, {ReactElement} from 'react'
import Grid from '@material-ui/core/Grid'
import {Trans} from 'react-i18next'
import Typography from '@material-ui/core/Typography'
import {WithStyles, withStyles} from '@material-ui/core'

import {Account} from '../../../../../../graphql/types'
import Amount from '../../../../../Common/Amount'
import messages from '../../../../../../assets/messages'
import {IbAccountDetails} from '../../types'
import {styles} from './styles'

interface Props extends WithStyles {
  account: Account | null
  ibAccountDetails: IbAccountDetails | null
}

function AccountOverviewBase(props: Props): ReactElement | null {
  const {account, classes, ibAccountDetails} = props
  if (!account || !ibAccountDetails) return null

  const renderAmountBlock = (labelToTranslate: {i18nKey: string}, amount: number) => (
    <>
      <Typography variant="caption">
        <Typography variant="caption">{<Trans {...labelToTranslate} />}</Typography>
      </Typography>
      <Amount
        value={amount}
        currency={account.currency}
        locale="en-US"
        classes={{
          root: classes.valueBody,
          currency: classes.amountCurrency,
          value: classes.amountValue,
          fraction: classes.amountFraction,
        }}
      />
    </>
  )

  const renderTextBlock = (labelToTranslate: {i18nKey: string}, value: number) => (
    <>
      <Typography variant="caption">{<Trans {...labelToTranslate} />}</Typography>
      <Typography variant="h1" className={classes.valueBody}>
        {value}
      </Typography>
    </>
  )

  return (
    <div className={classes.container}>
      <Typography variant="h3" className={classes.contentMargin}>
        <Trans {...messages.financialInfo} />
      </Typography>
      <Grid container>
        <Grid item lg={3} md={4} xs={12} className={classes.contentMargin}>
          {renderAmountBlock(messages.totalEarnedCommission, ibAccountDetails.paidCommission)}
        </Grid>
        <Grid item lg={3} md={4} xs={12} className={classes.contentMargin}>
          {renderAmountBlock(messages.unreleasedIbPayout, ibAccountDetails.unpaidCommission)}
        </Grid>
        <Grid item lg={3} md={4} xs={12} className={classes.contentMargin}>
          {renderTextBlock(messages.totalNumberOfClients, ibAccountDetails.totalFollowersCount)}
        </Grid>
        <Grid item lg={3} md={4} xs={12} className={classes.contentMargin}>
          {renderTextBlock(messages.newClientsThisMonth, ibAccountDetails.monthFollowersCount)}
        </Grid>
      </Grid>
    </div>
  )
}

export const AccountOverview = withStyles(styles, {withTheme: true})(AccountOverviewBase)
